<div class="mb-3">
  <app-bloco-remetente-destinatario [Pedido]="pedido"></app-bloco-remetente-destinatario>
</div>
<div class="bloco-unico mb-3">
  <h3 class="uppercase">Rastreamento</h3>
  <hr>
  <!-- <app-etapa-rastreamento [Pedido]="pedido?.tracking"></app-etapa-rastreamento> -->
  <app-bloco-historico-consulta [PedidoId]="pedido?.pedidoId"></app-bloco-historico-consulta>
</div>

<div class="mb-3 page-break">
  <app-bloco-rat [Pedido]="pedido"></app-bloco-rat>
</div>

<div class="mb-3 comprovantes">
  <app-bloco-comprovante [Pedido]="pedido" [Exibir]="false"></app-bloco-comprovante>
</div>
